export default {
  GET_DATATABLE_DATA: 'GET_DATATABLE_DATA',
  GET_AREA_ZIPCODE_DATATABLE_DATA: 'GET_AREA_ZIPCODE_DATATABLE_DATA'
}